import React from "react";
import PropTypes from "prop-types";
import HorizontalStackBar from "../../HorizontalStackBar/HorizontalStackBar";

function TotalPointsStatsBar({ data }) {
  let vincenti =
    data.winner.forehand +
    data.winner.backhand +
    data.winner.volley +
    data.winner.smash;
  let forzati =
    data.forced.forehand +
    data.forced.backhand +
    data.forced.volley +
    data.forced.smash;
  let gratuiti =
    data.error.forehand +
    data.error.backhand +
    data.error.volley +
    data.error.smash;

  const chartData = [
    {
      label: "Vincenti",
      value: vincenti,
      backgroundColor: "#5cb85c",
    },
    {
      label: "Forzati",
      value: forzati,
      backgroundColor: "#f0ad4e",
    },
    {
      label: "Gratuiti",
      value: gratuiti,
      backgroundColor: "#d9534f",
    },
  ];
  return (
    <HorizontalStackBar labels={["Colpi"]} data={chartData} title="Colpi" />
  );
}

TotalPointsStatsBar.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TotalPointsStatsBar;
